import React, { Component } from 'react'
import styled from 'styled-components'
import media from '@Styles/media'
import Icon from '@Components/Icon'
import { ButtonLink } from '@Components/Button'

class Modal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ownIsOpen: props.isOpen || true,
    }
  }

  close = () => {
    this.setState(() => ({ ownIsOpen: false }))
    if (this.props.onClose) this.props.onClose()
  }

  renderHeader = () => {
    const { title, closable, onClose } = this.props
    if (!title) return null

    return (
      <Header className="px-modal-header">
        <Title className="px-modal-header-title">
          <span>{title}</span>
        </Title>
        {(closable || onClose) && (
          <CloseButton onClick={this.close}>
            <Icon type={Icon.Types.close} />
          </CloseButton>
        )}
      </Header>
    )
  }

  render() {
    const { overlay, width, renderLogo, renderFooter, children } = this.props

    return (
      <FakePortal className="px-portal" tabIndex={0}>
        <Container className="px-modal-container">
          {overlay && <ModalOverlay />}
          <Inner className="px-modal-inner">
            <Dialog width={width}>
              <Body className="px-modal-body">
                {renderLogo && renderLogo()}
                {this.renderHeader()}
                {children}
                {renderFooter && renderFooter()}
              </Body>
            </Dialog>
          </Inner>
        </Container>
      </FakePortal>
    )
  }
}

const FakePortal = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
`

export const Container = styled.div`
  display: table;
  top: 0;
  left: 0;
  table-layout: fixed;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10000;
  font-size: 1.8rem;
`

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  transform: translate3d(0, 0, 0);

  ${media.smallScreen`
    display: none;
  `};
`

const Inner = styled.div`
  display: table-cell;
  vertical-align: middle;
  height: 100%;
  width: 100%;
`

const Dialog = styled.div`
  text-align: center;
  max-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${({ width }) => `${width}px` || '80%'};
  min-width: ${({ width }) => `${width}px`};
  max-width: max-content;
  padding: ${({ theme }) => theme.sizes.gutterLarger};
  color: ${({ theme }) => theme.colors.pressly};
  overflow-y: auto;
  margin: 0 auto;
  background-color: #fff;
  box-shadow: 0 0 27px 0 rgba(53, 53, 53, 0.5);
  position: relative;
  z-index: 10002;
  border-radius: 3px;

  word-wrap: break-word;
  overflow-wrap: break-word;

  ${media.smallScreen`
    max-height: 100%;
    padding-bottom: 100px;
  `};

  h1 {
    margin: 0;
    color: ${({ theme }) => theme.colors.pressly};
    font-size: ${({ theme }) => theme.fontSizes.fontSizeNormal};
    text-align: center;
    font-weight: 500;
  }

  input:-webkit-autofill:active,
  input:-webkit-autofill {
    background: ${({ theme }) => theme.colors.grayLightest};
    -webkit-box-shadow: 0 0 0 1000px ${({ theme }) => theme.colors.grayLightest} inset;
  }

  input:-webkit-autofill:focus {
    background: ${({ theme }) => theme.colors.grayLightest};
    -webkit-box-shadow: 0 0 0 1000px ${({ theme }) => theme.colors.grayLightest} inset;
  }

  input:-webkit-autofill:active,
  input:-webkit-autofill {
    background: #fff !important;
    -webkit-box-shadow: 0 0 0 1000px #fff inset;
    -webkit-text-fill-color: #333;
  }

  ${media.smallScreen`
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
    margin: 0;
    max-width: none;
    display: flex;
    flex-direction: column;
    overflow: auto;
  `};
`

const Body = styled.div``

const HEADER_HEIGHT = '50px'

const Header = styled.div`
  padding: 0 ${({ theme }) => theme.sizes.gutterLarge};
  font-weight: 400;
  overflow: hidden;
  height: ${HEADER_HEIGHT};
`

const Title = styled.h2`
  margin: 0;
  height: 46px;
  line-height: 46px;
  font-family: Roboto, 'Helvetica Neue', -apple-system, BlinkMacSystemFont, Arial, sans-serif;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.fontSizeNormal};
  color: #1a1a1a;
  padding-bottom: 25px;

  ${media.smallScreen`
    font-size: ${({ theme }) => theme.fontSizes.fontSizeSmall}
  `};
`

const CloseButton = styled(ButtonLink)`
  display: block;
  color: ${({ theme }) => theme.colors.grayMedium};
  position: absolute;
  top: 0;
  right: 0;
  width: 54px;
  height: 54px;
  line-height: 54px;
  text-align: center;

  span {
    color: #000;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.grayDark};
  }

  &:focus {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.accessibilityOutlineColor};
  }
`

export default Modal
